export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  UseAllStylesInCart: 'specs.stores.UseAllStylesInCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  FixRedundantGetAfterUpdate: 'specs.stores.FixRedundantGetAfterUpdate',
  SendCartLoadedAfterEstimate: 'specs.stores.SendCartLoadedAfterEstimate',
  UseProductThumbnailWithWowImage: 'specs.stores.UseProductThumbnailWithWowImage',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  UseDeliveryOptionsLibInCart: 'specs.ecom.UseDeliveryOptionsLibInCart',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  FixCarrierIdForSelectShippingOption: 'specs.ecom.FixCarrierIdForSelectShippingOption',
  FixCouponCss: 'specs.ecom.FixCouponCss',
  SupportPaymentCurrency: 'specs.ecom.SupportPaymentCurrency',
  EmptyCartA11yFix: 'specs.ecom.EmptyCartA11yFix',
  SupportModifiersOnCart: 'specs.ecom.SupportModifiersOnCart',
  SideCartCouponAndNote: 'specs.ecom.SideCartCouponAndNote',
  SideCartNote: 'specs.ecom.SideCartNote',
  UseEcommerceSettingsInCart: 'specs.ecom.UseEcommerceSettingsInCart',
  FixPricesOnDeliveryMethodDropdown: 'specs.ecom.FixPricesOnDeliveryMethodDropdown',
  ClientFormattingForPrices: 'specs.ecom.ClientFormattingForPrices',
  UseAdditionalEcommerceSettings: 'specs.ecom.UseAdditionalEcommerceSettings',
  UsePayableCurrencies: 'specs.ecom.UsePayableCurrencies',
  SupportGetFormattingFunction: 'specs.ecom.SupportGetFormattingFunction',
  SendCurrencyToExpressWidget: 'specs.ecom.SendCurrencyToExpressWidget',
  CartButtonBIEvents: 'specs.ecom.CartButtonBIEvents',
  DeprecatePaypalOnlyFlowInCart: 'specs.ecom.DeprecatePaypalOnlyFlowInCart',
  FixExpressWrongTotalAmount: 'specs.ecom.FixExpressWrongTotalAmount',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  StopUsingPaymentMethodsInCart: 'specs.ecom.StopUsingPaymentMethodsInCart',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  UseNewControllerFactoryInSideCart: 'specs.ecom.UseNewControllerFactoryInSideCart',
  UseNewControllerFactoryInCart: 'specs.ecom.UseNewControllerFactoryInCart',
  FixFormattingOnRTL: 'specs.ecom.FixFormattingOnRTL',
  SkipCreateCheckoutFromCartForV2: 'specs.ecom.SkipCreateCheckoutFromCartForV2',
} as const;
